/**
 * Resolve an IANA timezone string from a coordinate pair.
 *
 * Wraps the `tz-lookup` package (pure JS, ~50KB, no network calls). Used
 * by EventForm to auto-populate `event.timezone` when the organizer picks
 * or changes the venue location — the venue's coordinates are the source
 * of truth for what tz the event is in.
 *
 * Returns null when the coordinates are out of range or tz-lookup throws.
 * Callers fall back to whatever the form already had (or empty string).
 */
// @ts-expect-error tz-lookup ships no types; the runtime export is `(lat, lng) => string`.
import tzlookup from 'tz-lookup';

export function coordinatesToTimezone(
  coords: { lat: number; lng: number } | null | undefined,
): string | null {
  if (!coords) return null;
  try {
    return tzlookup(coords.lat, coords.lng);
  } catch {
    return null;
  }
}
